import Home from '../components/pages/home/Home'
import NotFound from '../components/pages/404/NotFound'
import Login from '../components/pages/login/Login'
import Recover from '../components/pages/forgotpassword/Recover'
import Reset from '../components/pages/forgotpassword/Reset'
import Register from '../components/pages/register/Register'
import UpdatePass from '../components/pages/updatepass/UpdatePass'
import Profile from '../components/pages/profile/Profile'
import Users from '../components/pages/users/Users'
import ServerConfig from '../components/pages/server-config/ServerConfig'
import FileProcesses from '../components/pages/fileprocesses/FileProcesses';
import Charts from '../components/pages/charts/Charts'
import LibertyInventory from '../components/pages/reports/LibertyInventory'
// import SourceInventory from '../components/pages/reports/SourceInventory'
import PartsInventory from '../components/pages/reports/PartsInventory'
import ReceivingReport from '../components/pages/reports/ReceivingReport'
import SaleOrdersAssetDetail from '../components/pages/reports/SaleOrdersAssetDetail'
import SaleOrdersByStatus from '../components/pages/reports/SaleOrdersByStatus'


const routes = [
    {
      id: 'login',
      name: 'login',
      path: '/',
      exact: true,
      protected: false,
      component: Login,
    },
    {
      id: 'recover',
      name: 'recover',
      path: '/recover',
      exact: true,
      protected: false,
      component: Recover,
    },
    {
      id: 'reset',
      name: 'reset',
      path: '/reset/:id/:token',
      exact: true,
      protected: false,
      component: Reset,
    },
    {
      id: 'register',
      name: 'register',
      path: '/register',
      exact: true,
      protected: false,
      component: Register,
    },
    {
      id: 'home',
      name: 'home',
      path: '/home',
      exact: true,
      protected: false,
      component: Home,
    },
    {
      id: 'profile',
      name: 'profile',
      path: '/profile',
      exact: true,
      protected: false,
      component: Profile,
    },
    {
      id: 'serverconfig',
      name: 'serverconfig',
      path: '/serverconfig',
      exact: true,
      protected: false,
      component: ServerConfig,
    },
    {
      id: 'users',
      name: 'users',
      path: '/users',
      exact: true,
      protected: false,
      component: Users,
    },
    {
      id: 'updatepass',
      name: 'updatepass',
      path: '/updatepass',
      exact: true,
      protected: false,
      component: UpdatePass,
    },
    {
      id: 'Charts',
      name: 'Charts',
      path: '/reports/charts',
      exact: true,
      protected: false,
      component: Charts,
    },
    // {
    //   id: 'SourceInventory',
    //   name: 'SourceInventory',
    //   path: '/reports/sourceInventory',
    //   exact: true,
    //   protected: false,
    //   component: SourceInventory,
    // },
    {
      id: 'LibertyInventory',
      name: 'LibertyInventory',
      path: '/reports/inventory',
      exact: true,
      protected: false,
      component: LibertyInventory,
    },
    {
      id: 'PartsInventory',
      name: 'PartsInventory',
      path: '/reports/partsInventory',
      exact: true,
      protected: false,
      component: PartsInventory,
    },
    {
      id: 'ReceivingReport',
      name: 'ReceivingReport',
      path: '/reports/receivingReport',
      exact: true,
      protected: false,
      component: ReceivingReport,
    },
    {
      id: 'SaleOrdersAssetDetail',
      name: 'SaleOrdersAssetDetail',
      path: '/reports/orders/assetDetail',
      exact: true,
      protected: false,
      component: SaleOrdersAssetDetail,
    },
    {
      id: 'SaleOrdersByStatus',
      name: 'SaleOrdersByStatus',
      path: '/reports/orders/status',
      exact: true,
      protected: false,
      component: SaleOrdersByStatus,
    },
    {
      id: 'fileprocesses',
      name: 'fileprocesses',
      path: '/fileprocesses',
      exact: true,
      protected: false,
      component: FileProcesses,
    },
    
    /* Error route */
    {
      id: '404',
      name: 'Not Found',
      path: '*',
      exact: true,
      protected: false,
      component: NotFound,
    },
]; 

export default routes;
